// Logique déplacée dans pages/decisionnel/ — maintenu pour compatibilité App.js
export { default } from './decisionnel/index';
